export const getFavoriteMediumIds = (): string[] => {
    try {
        const stored = localStorage.getItem('astro_favorite_mediums');
        return stored ? JSON.parse(stored) : [];
    } catch {
        return [];
    }
};

export const isMediumFavorite = (id: string): boolean => {
    return getFavoriteMediumIds().includes(id);
};

export const toggleFavoriteMedium = (id: string): string[] => {
    const current = getFavoriteMediumIds();
    let updated: string[];
    if (current.includes(id)) {
        updated = current.filter(item => item !== id);
    } else {
        updated = [...current, id];
    }
    try {
        localStorage.setItem('astro_favorite_mediums', JSON.stringify(updated));
        window.dispatchEvent(new CustomEvent('astro_favorites_updated'));
    } catch (e) {
        console.error('Failed to save favorites', e);
    }
    return updated;
};
